/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { POST_SD_EXTERNALUSER_LINK_ACCOUNT } from './actionTypes';

/**
 * Updates the details in the 'ExternalUserLinkAccount' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postSdExternaluserLinkAccountReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_SD_EXTERNALUSER_LINK_ACCOUNT);

/**
 * Updates the indicator of creation of details in the 'ExternalUserLinkAccount' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostSdExternaluserLinkAccountReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_SD_EXTERNALUSER_LINK_ACCOUNT);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postSdExternaluserLinkAccountErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_SD_EXTERNALUSER_LINK_ACCOUNT);

const reducers = combineReducers({
  postSdExternaluserLinkAccount: postSdExternaluserLinkAccountReducer,

  isFetchingPostSdExternaluserLinkAccount: isFetchingPostSdExternaluserLinkAccountReducer,
  postSdExternaluserLinkAccountError: postSdExternaluserLinkAccountErrorReducer,
});

export default { reducers };
